import { getSupportedCountryCurrency } from '@change-corgi/config/currency';
import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { getSubscriptionConfig } from 'src/app/shared/api/payments';

import type { MembershipBottomBannerDataQuery, MembershipBottomBannerDataQueryVariables } from './api.graphql';
import { MembershipBottomBannerData as MembershipBottomBannerDataQ } from './api.graphql';

type SubscriptionConfig =
	| Pick<NonNullable<Awaited<ReturnType<typeof getSubscriptionConfig>>>, 'amounts' | 'defaultAmount'>
	| undefined;

export type MembershipBottomBannerData = {
	subscriptionConfig?: SubscriptionConfig;
	featureConfigs: MembershipBottomBannerDataQuery['featureConfigs'];
	currency: string;
};

export async function getMembershipBottomBannerData(
	utilityContext: UtilityContext,
	{
		countryCode,
	}: {
		countryCode: string;
	},
): Promise<MembershipBottomBannerData> {
	const currency = getSupportedCountryCurrency(countryCode) || 'USD';

	const [{ data }, subscriptionConfig] = await Promise.all([
		utilityContext.gql.fetch<MembershipBottomBannerDataQuery, MembershipBottomBannerDataQueryVariables>({
			query: MembershipBottomBannerDataQ,
			rejectOnError: true,
		}),
		getSubscriptionConfig(utilityContext, currency),
	]);

	return {
		currency,
		subscriptionConfig: subscriptionConfig
			? { amounts: subscriptionConfig.amounts, defaultAmount: subscriptionConfig.defaultAmount }
			: undefined,
		featureConfigs: data.featureConfigs,
	};
}
